var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
import { hide } from "./services";
import InstanceDropdown from "@/components/ConfigTemplates/InstanceDropdown.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InstanceDropdown',
    props: {
        fileSource: null
    },
    emits: ["entryRemoved"],
    setup(__props, { emit }) {
        const props = __props;
        const fileSourceTemplatesStore = useFileSourceTemplatesStore();
        const routeEdit = computed(() => `/file_source_instances/${props.fileSource.uuid}/edit`);
        const routeUpgrade = computed(() => `/file_source_instances/${props.fileSource.uuid}/upgrade`);
        const isUpgradable = computed(() => fileSourceTemplatesStore.canUpgrade(props.fileSource.template_id, props.fileSource.template_version));
        function onRemove() {
            return __awaiter(this, void 0, void 0, function* () {
                yield hide(props.fileSource);
                emit("entryRemoved");
            });
        }
        return { __sfc: true, fileSourceTemplatesStore, props, routeEdit, routeUpgrade, isUpgradable, onRemove, emit, InstanceDropdown };
    }
});
